/**
 * Client Admin API Service
 * Hook for ClientAdmin scoped endpoints (/api/client-admin/*)
 */
import { useCallback, useMemo } from "react";
import { useApi } from "@/hooks/use-api";
import type { ClientAdminBridgeResponse, ClientAdminProfileDto } from "@/types/api/client-admin";

export function useClientAdminApi() {
    const api = useApi();

    /** Get the current ClientAdmin's profile (clientId, clientName, hasBridge, isEmailIngestionEnabled) */
    const getProfile = useCallback(async (): Promise<ClientAdminProfileDto> => api.get<ClientAdminProfileDto>("/client-admin/me"), [api]);

    /** Get the current client's bridge registration(s) with heartbeat data */
    const getBridges = useCallback(async (): Promise<ClientAdminBridgeResponse> => api.get<ClientAdminBridgeResponse>("/client-admin/bridge"), [api]);

    return useMemo(() => ({ getProfile, getBridges }), [getProfile, getBridges]);
}
